import { render } from "./MetadataItem.vue?vue&type=template&id=3c1eab3d"
import script from "./MetadataItem.vue?vue&type=script&lang=js"
export * from "./MetadataItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__